var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import { Link, useMediaQuery } from "@mui/material";
import Button from '@mui/material/Button';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Accordion, AccordionDetails, AccordionSummary, } from '@mui/material';
import { BusinessCenterOutlined, ExpandMore } from '@mui/icons-material';
import { v1 } from "@variable/ui-icons/dist";
import { ThemeProvider } from "@mui/material/styles";
import theme from '../theme';
import Badge from '@mui/material/Badge';
import LogoutIcon from '@mui/icons-material/Logout';
import { pxToRem } from '../conversion';
import { Avatar } from "@mui/material";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import ArchitectureOutlinedIcon from '@mui/icons-material/ArchitectureOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import PopupMenu from './PopupMenu';
import { ButtonIconType, getIconByType } from './ButtonWithIcon';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
function HamburgerMenu(props) {
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (_jsx(PopupMenu, { items: [
            { icon: ButtonIconType.edit, text: 'Edit Profile', onClick: function () { var _a; return (_a = props === null || props === void 0 ? void 0 : props.actions) === null || _a === void 0 ? void 0 : _a.editUser(__assign({}, props.user)); } },
            { icon: ButtonIconType.create, text: 'Create Organization', onClick: function () { location.href = "/organizations/new"; } }
        ] }));
}
function VariableSvgIcon(props) {
    switch (props.key) {
        default:
            return v1.LogoWebWhite(props);
        case 'dashboard':
            return _jsx(DashboardOutlinedIcon, __assign({}, props));
        case 'variable':
        case "variables":
            return v1.Logo(props);
        case "my_skills":
        case "skills":
            return _jsx(ArchitectureOutlinedIcon, __assign({}, props));
        case "partner":
        case "partners":
            return _jsx(HandshakeOutlinedIcon, __assign({}, props));
        case "connect":
        case "connection":
        case "connections":
            return v1.Connections(props);
        case "course":
        case "courses":
        case "training":
        case "trainings":
            return v1.Training(props);
        case "opportunities":
            return v1.Opportunities(props);
        case "groups":
        case "roles & permissions":
        case "roles_permissions":
            return v1.GroupsSmall(props);
        case "people":
        case "person":
            return v1.UserMultiple(props);
        case "job_board":
            return _jsx(WorkOutlineOutlinedIcon, __assign({}, props));
        case "certifications":
        case "certificates":
            return _jsx(VerifiedOutlinedIcon, __assign({}, props));
        case "forms":
            return _jsx(DescriptionOutlinedIcon, __assign({}, props));
        case "cor":
        case "cors":
        case "initiatives":
            return _jsx(BusinessCenterOutlined, __assign({}, props));
        case "libraries":
            return _jsx(LibraryAddOutlinedIcon, __assign({}, props));
    }
    return _jsx(_Fragment, {});
}
var LeftNavigation = function (props) {
    var _a, _b, _c;
    var _d = React.useState(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var open = Boolean(anchorEl);
    var _e = React.useState(props.activeOrg || ''), activeOrg = _e[0], setActiveOrg = _e[1];
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _f = useState({}), organizationMenus = _f[0], setOrganizationMenus = _f[1];
    useEffect(function () {
        function fetchData() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var menu, cacheData;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (activeOrg in organizationMenus === false) {
                                try {
                                    cacheData = localStorage.getItem("organizationMenu_".concat(activeOrg));
                                    if (cacheData) {
                                        menu = JSON.parse(cacheData);
                                        (_a = menu === null || menu === void 0 ? void 0 : menu.sections) === null || _a === void 0 ? void 0 : _a.forEach(function (s) { return s.active = false; });
                                        setOrganizationMenus(function (menus) {
                                            var _a;
                                            return (__assign(__assign({}, menus), (_a = {}, _a[activeOrg] = menu, _a)));
                                        });
                                    }
                                }
                                catch (e) {
                                    console.error(e);
                                }
                            }
                            return [4 /*yield*/, props.loadOrganizationMenu(activeOrg)];
                        case 1:
                            menu = _b.sent();
                            setOrganizationMenus(function (menus) {
                                var _a;
                                return (__assign(__assign({}, menus), (_a = {}, _a[activeOrg] = menu, _a)));
                            });
                            localStorage.setItem("organizationMenu_".concat(activeOrg), JSON.stringify(menu));
                            return [2 /*return*/];
                    }
                });
            });
        }
        activeOrg && fetchData();
    }, [activeOrg]);
    var loadOrganizationMenu = function (activeOrg) {
        var _a;
        var menu = organizationMenus[activeOrg] || {};
        return (_jsx(List, __assign({ sx: { paddingTop: 0, paddingBottom: 0 } }, { children: (_a = menu === null || menu === void 0 ? void 0 : menu.sections) === null || _a === void 0 ? void 0 : _a.filter(function (a) {
                return a.key !== "edit_profile";
            }).map(function (section, index) { return (_jsx(Link, __assign({ sx: { textDecoration: "none" }, href: section.url }, { children: _jsx(ListItem, __assign({ disablePadding: true, sx: { pl: section.is_sub ? 4 : 0 } }, { children: _jsxs(ListItemButton, __assign({ sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            pointerEvents: !section.url && 'none',
                            "&.selected": {
                                background: "var(--palette-white-10p) 0% 0% no-repeat padding-box",
                                borderRadius: "30px",
                            },
                            "&:hover": {
                                opacity: 0.7,
                            },
                        }, className: section.active !== undefined &&
                            section.active
                            ? "selected"
                            : "" }, { children: [_jsxs("div", __assign({ style: {
                                    display: "flex",
                                    alignItems: "center",
                                } }, { children: [_jsx(ListItemIcon, { children: VariableSvgIcon({
                                            style: {
                                                width: "20px",
                                                height: "20px",
                                                color: "var(--unnamed-color-ffffff)",
                                                fill: "var(--unnamed-color-ffffff)",
                                            },
                                            key: section.key,
                                        }) }), _jsx(ListItemText, { primary: section.name, sx: {
                                            color: "var(--unnamed-color-ffffff)",
                                        } })] })), !section.notes &&
                                section.count &&
                                section.count !== "0" && (_jsx(Badge, { max: 999, sx: {
                                    "& .MuiBadge-badge": {
                                        borderRadius: "30px",
                                        padding: "10px 13px",
                                        backgroundColor: "var(--palette-white-10p)",
                                    },
                                }, badgeContent: section.count, style: {
                                    color: "var(--palette-unamed-ffffff)",
                                    borderRadius: "30px",
                                    marginRight: "10px",
                                } })), !!section.notes &&
                                section.notes > 0 && (_jsx(Badge, { max: 999, sx: {
                                    "& .MuiBadge-badge": {
                                        borderRadius: "30px",
                                        padding: "10px 13px",
                                        backgroundColor: "var(--palette-error-main)",
                                    },
                                }, badgeContent: section.notes, style: {
                                    color: "var(--palette-unamed-ffffff)",
                                    borderRadius: "30px",
                                    marginRight: "10px",
                                } }))] })) })) }), "".concat(section.url, "__").concat(index))); }) })));
    };
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Box, __assign({ style: { width: isMobile ? "100%" : "300px", height: '100vh', position: 'sticky', top: 0, backgroundColor: "var(--palette-black-1)" } }, { children: _jsxs(Box, __assign({ flexGrow: 1, sx: {
                    width: '100%',
                    overflowY: 'auto',
                    minHeight: 'fit-content',
                    maxHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'inherit',
                    justifyContent: 'space-between',
                    flexGrow: "1"
                } }, { children: [_jsxs(AppBar, __assign({ color: "transparent", elevation: 0, className: 'd-flex flex-column justify-content-between mb-5', position: "sticky" }, { children: [_jsxs("div", __assign({ style: { position: 'sticky', top: '0', zIndex: '99', backgroundColor: 'var(--palette-black-1)' } }, { children: [!isMobile && _jsx("div", __assign({ style: { display: 'flex', justifyContent: 'center', padding: '20px' } }, { children: _jsx(v1.Variable2, {}) })), isMobile &&
                                        _jsxs("div", __assign({ style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--palette-black-1) 0% 0% no-repeat padding-box', padding: '0 10px' } }, { children: [_jsx(IconButton, __assign({ onClick: function () { return props.setDrawerOpen(!props.drawerOpen); } }, { children: _jsx(MenuIcon, { sx: { color: 'white' } }) })), _jsx(v1.Variable2, {}), _jsx(Box, __assign({ sx: {
                                                        display: 'flex', alignItems: 'center', background: '#FFFFFF26 0% 0% no-repeat padding-box',
                                                        borderRadius: '4px', padding: '15px 10px', margin: '10px'
                                                    } }, { children: _jsx(Avatar, { src: ((_b = (_a = props.editUser) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.image) || "" }) }))] }))] })), _jsxs(Box, __assign({ sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: '#FFFFFF26 0% 0% no-repeat padding-box',
                                    borderRadius: '4px',
                                    padding: '15px 10px',
                                    margin: '10px'
                                } }, { children: [_jsx(Avatar, { src: props.user.image || "" }), _jsx(Typography, __assign({ sx: { font: 'normal normal medium 20px/24px Lato', letterSpacing: '0.3px', color: '#FFFFFF', fontSize: pxToRem(20), paddingLeft: '10px' } }, { children: props.user.name })), _jsx("div", __assign({ style: { display: "flex", flexWrap: "wrap", justifyContent: "flex-end", flexGrow: "1" } }, { children: HamburgerMenu(props) }))] })), _jsx(List, { children: props.user.sections.filter(function (a) { return a.key !== "edit_profile"; }).map(function (section, index) { return (_jsx(ListItem, __assign({ disablePadding: true }, { children: _jsx(Link, __assign({ sx: { textDecoration: "none", width: "100%" }, href: section.url }, { children: _jsxs(ListItemButton, __assign({ sx: {
                                                padding: '4px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                                "&.selected": {
                                                    background: 'var(--palette-white-10p) 0% 0% no-repeat padding-box',
                                                    borderRadius: '30px',
                                                    margin: '10px',
                                                },
                                                "&:hover": {
                                                    opacity: 0.7
                                                },
                                            }, className: (section.active !== undefined && section.active) ? 'selected' : "" }, { children: [_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(ListItemIcon, { children: VariableSvgIcon({
                                                                sx: { width: "20px", height: "20px" },
                                                                style: { width: "20px", height: "20px", color: 'var(--unnamed-color-ffffff)', fill: 'var(--unnamed-color-ffffff)' },
                                                                key: section.key,
                                                            }) }), _jsx(ListItemText, { primary: section.name, sx: { color: 'var(--unnamed-color-ffffff)' } })] })), section.count && section.count !== "0" && _jsx(Badge, { max: 999, className: section.key ? section.key : "", sx: {
                                                        "& .MuiBadge-badge": {
                                                            borderRadius: "30px",
                                                            padding: "10px 13px",
                                                            backgroundColor: "".concat(section.key !== 'dashboard' ? "var(--palette-white-10p)" : "var(--palette-error-main)")
                                                        }
                                                    }, badgeContent: section.count, style: { color: "var(--palette-unamed-ffffff)", borderRadius: "30px", marginRight: '10px' } })] })) })) }), "".concat(section.url, "__").concat(index))); }) }), props.organizations.length > 0 &&
                                props.organizations.map(function (organization, id) { return (_jsxs(Box, { children: [_jsxs(Accordion, __assign({ id: organization.id, onChange: function (event, expanded) {
                                                setActiveOrg(organization === null || organization === void 0 ? void 0 : organization.id);
                                            }, expanded: activeOrg && activeOrg === organization.id ? true : false, disableGutters: true }, { children: [_jsx(AccordionSummary, __assign({ "aria-controls": "accordion-".concat(organization.id), id: "accordion-".concat(organization.id), expandIcon: _jsx(ExpandMore, { sx: { fill: 'var(--unnamed-color-ffffff)' } }), disableRipple: true, sx: {
                                                        display: 'flex', background: '#FFFFFF26 0% 0% no-repeat padding-box',
                                                        borderRadius: '4px', padding: '0 10px', margin: '10px',
                                                        "& .MuiButton-root": { display: "none" },
                                                        "&:hover .MuiButton-root": {
                                                            display: "flex",
                                                            backgroundColor: "transparent",
                                                            color: 'white',
                                                            position: 'absolute',
                                                            right: '5px',
                                                            opacity: 1,
                                                        },
                                                        "&:hover": {
                                                            background: '#FFFFFF0D 0% 0% no-repeat padding-box',
                                                        },
                                                        "&:hover p": {
                                                            opacity: 0.6,
                                                            textDecoration: 'none',
                                                        }
                                                    }, onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            setActiveOrg(organization === null || organization === void 0 ? void 0 : organization.id);
                                                            return [2 /*return*/];
                                                        });
                                                    }); } }, { children: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center' } }, { children: [_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [_jsx(Avatar, { src: organization.image || "" }), _jsx(Link, __assign({ sx: {
                                                                            color: 'white !important',
                                                                            textDecoration: 'none',
                                                                            "&:hover": {
                                                                                opacity: 0.6,
                                                                                textDecoration: 'none',
                                                                            }
                                                                        }, href: (organization === null || organization === void 0 ? void 0 : organization.sections) ? organization === null || organization === void 0 ? void 0 : organization.sections.filter(function (section) { return section.key === 'dashboard'; })[0].url : "" }, { children: _jsx(Typography, __assign({ sx: {
                                                                                font: 'normal normal medium 16px/19px Lato', letterSpacing: '0.8px', color: '#FFFFFF', paddingLeft: '10px',
                                                                                textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '135px',
                                                                                "&:hover": {
                                                                                    opacity: 0.6,
                                                                                    textDecoration: 'none',
                                                                                }
                                                                            }, title: organization.name }, { children: organization.name })) }))] })), _jsxs(Button, __assign({ onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                                                    return __generator(this, function (_a) {
                                                                        switch (_a.label) {
                                                                            case 0:
                                                                                if (!(props.actions && props.actions.editOrganization)) return [3 /*break*/, 2];
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                                return [4 /*yield*/, props.actions.editOrganization(__assign({}, organization))];
                                                                            case 1:
                                                                                _a.sent();
                                                                                _a.label = 2;
                                                                            case 2: return [2 /*return*/];
                                                                        }
                                                                    });
                                                                }); }, sx: {
                                                                    color: "white",
                                                                    textDecoration: 'none',
                                                                    marginRight: '20px',
                                                                } }, { children: [getIconByType(ButtonIconType.edit, { fontSize: 'small', sx: { width: '15px' } }), _jsx("span", __assign({ style: {
                                                                            font: 'normal normal medium 16px/24px Lato', letterSpacing: '0.3px',
                                                                            color: '#FFFFFF', paddingLeft: '3px'
                                                                        } }, { children: "Edit" }))] }))] })) })), _jsx(AccordionDetails, __assign({ sx: {
                                                        paddingTop: 0, paddingBottom: 0,
                                                        marginBottom: (props.organizations.length - 1 === id) ? '40px' : ''
                                                    } }, { children: _jsx("div", { children: activeOrg && loadOrganizationMenu(activeOrg) }) }))] })), _jsx(Divider, {})] }, "Accordion-Box-".concat(id))); }), _jsx(List, { children: (_c = props.pendingOrganizations) === null || _c === void 0 ? void 0 : _c.map(function (org) {
                                    return (_jsx(ListItem, __assign({ sx: { display: "block", color: "var(--unnamed-color-ffffff)" }, secondaryAction: _jsxs("div", __assign({ style: { marginRight: "5px" } }, { children: [_jsx(Button, __assign({ onClick: function () { window.location.href = org.declineURL; }, variant: "text", sx: {
                                                        font: "var(--unnamed-font-style-normal) normal 600 var(--unnamed-font-size-16)/var(--unnamed-line-spacing-19) var(--unnamed-font-family-lato)",
                                                        letterSpacing: "var(--unnamed-character-spacing-0-32)",
                                                        color: "var(--palette-secondary-main)",
                                                        textAlign: "left"
                                                    } }, { children: "Deny" })), _jsx(Button, __assign({ sx: {
                                                        background: "var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box",
                                                        borderRadius: "4px",
                                                        font: "var(--unnamed-font-style-normal) normal 600 var(--unnamed-font-size-16)/var(--unnamed-line-spacing-19) var(--unnamed-font-family-lato)",
                                                        letterSpacing: "var(--unnamed-character-spacing-0-32)",
                                                        color: "var(--palette-black-1)",
                                                        textAlign: "left",
                                                        "&:hover": {
                                                            background: "var(--palette-offwhite-5)"
                                                        }
                                                    }, onClick: function () { window.location.href = org.acceptURL; } }, { children: "Join" }))] })) }, { children: _jsx(Typography, __assign({ sx: { overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", width: "60%" } }, { children: org.name })) }), "".concat(org.id, "_").concat(org.name)));
                                }) })] })), _jsx(Button, __assign({ sx: {
                            border: 'none',
                            color: 'tomato',
                            textTransform: 'none',
                            width: 'inherit',
                            paddingTop: '10px',
                            paddingBottom: '10px',
                            zIndex: 9999,
                            background: 'rgb(28 30 50)',
                            '&:hover': {
                                border: 'none',
                                color: 'red',
                            }
                        }, variant: "outlined", onClick: function () {
                            window.location.href = props.urls.logoutURL;
                        }, startIcon: _jsx(LogoutIcon, {}) }, { children: "Logout" }))] })) })) })));
};
export default LeftNavigation;
